<app-tile class="flex flex-col gap-[24px]">
  <div class="flex flex-col">
    <h3>
      {{ gatewayStore.getDeviceRoles(deviceId) | async | translateDeviceByRoles }}
    </h3>
    <div [appText]="3" class="app-ellipsis">
      {{ deviceId | idPrefixRemover | serialSpacing }}
    </div>
  </div>
  <div class="flex flex-col gap-[24px] justify-start items-start">
    <ng-container *ngIf="isDeviceETRVOrFHT(deviceId) | async">
      <ng-container *ngIf="circuits$ | async | ready as circuits">
        <mat-form-field mat-select-height-medium data-at-comissioning-room-heater-circuit-select>
          <mat-label>
            {{ '+COMMISSIONING.DEVICE_PANEL.HEATING_CIRCUIT.LABEL' | translate }}
          </mat-label>
          <mat-select
            data-at-comissioning-room-heater-circuit-select-options
            [value]="getHeatingCircuitId() | async"
            (valueChange)="onAssignHeatingCircuit($event, deviceId)"
            [disabled]="isDeviceFHTChannel(deviceId) | async"
          >
            <mat-option
              *ngFor="let cId of circuits | featureValue: 'enabled'"
              [value]="cId"
              gtm="onSelect"
              gtmAction="Heating circuit for device"
              gtmCategory="devicePanel"
            >
              <span data-at-comissioning-room-heater-circuit-select-option>{{
                installationService.getCircuitName(cId) | async
              }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </ng-container>

    <!-- fht.valve.burnInMode -->
    <app-feature-list-item
      data-at-channel-valve-burn-in-mode
      *ngIf="burnInMode$ | async | ready as feature"
      [label]="'+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_BURN_IN_MODE.TITLE' | translate"
      [isNgContent]="true"
      [editable]="true"
      [forInput]="true"
      [attr.data-feature]="feature.feature"
    >
      <ng-container *ngIf="feature.properties?.active?.value">
        {{ '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_BURN_IN_MODE.DURATION' | translate }}: 6
        {{ '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_BURN_IN_MODE.DURATION_UNIT' | translate }}
      </ng-container>
      <mat-slide-toggle
        (click)="onBurnInModeChange($event, !feature.properties?.active?.value)"
        [checked]="feature.properties?.active?.value"
      ></mat-slide-toggle>
    </app-feature-list-item>

    <!-- fht.configuration.demandRelayMode -->
    <app-feature-list-item
      data-at-fht-configuration-demandRelayMode
      *ngIf="fhtDemandRelayMode$ | async | ready as feature"
      [label]="'+INSTALLATIONS.SRC.ETRV.FHT_DEMAND_RELAY_MODE.TITLE' | translate"
      [isNgContent]="true"
      [attr.data-feature]="feature.feature"
    >
      <mat-slide-toggle
        data-at-toggle-fht-configuration-demandRelayMode
        gtm="onToggle"
        gtmAction="FHT Demand Relay Mode"
        gtmCategory="singleRoomControl"
        [disabled]="!(feature | executable: FeatureCommands.setValue)"
        [checked]="feature?.properties?.value?.value === fhtDemandRelayModeValues.automatic"
        (change)="onFHTDemandRelayModeChange($event)"
      ></mat-slide-toggle>
    </app-feature-list-item>

    <ng-container *ngIf="isDeleteable; then deleteDeviceBtn; else unassignDeviceBtn"></ng-container>

    <ng-template #deleteDeviceBtn>
      <div>
        <button
          mat-stroked-button
          color="primary"
          gtm="onOpen"
          gtmAction="Delete device confirmation panel"
          gtmCategory="devicePanel"
          (click)="deleteDeviceFromRoomAttempt()"
        >
          <mat-icon>delete</mat-icon>
          <span>{{ '+COMMISSIONING.BUTTON.DELETE_DEVICE' | translate }}</span>
        </button>
      </div>
    </ng-template>

    <ng-template #unassignDeviceBtn>
      <mat-icon
        *ngIf="!(installationFeaturesStore.canRemoveClimateAndCo2SensorFromRoom(deviceId) | async)"
        matTooltip="{{
          '+COMMISSIONING.DEVICE.TOOLTIP.INFO_REMOVE_CLIMATE_CO2_SENSOR_FROM_ROOM' | translate
        }}"
      >
        error_outline
      </mat-icon>

      <button
        data-at-comissioning-room-device-btn-delete
        *ngIf="installationFeaturesStore.canRemoveClimateAndCo2SensorFromRoom(deviceId) | async"
        mat-stroked-button
        color="primary"
        gtm="onUnassignDevice"
        (click)="unassignDeviceFromRoomAttempt(deviceId)"
      >
        <mat-icon>delete</mat-icon>
        <span>{{ '+COMMISSIONING.BUTTON.UNASSIGN_DEVICE' | translate }}</span>
      </button>
    </ng-template>
  </div>

  <ng-container *ngIf="mountingMode$ | async | ready as mountingMode">
    <app-banner *ngIf="mountingMode?.properties?.active?.value">
      {{ '+COMMISSIONING.DEVICE_INDICATOR.MOUNTING_MODE_WARNING.MESSAGE' | translate }}
    </app-banner>
  </ng-container>
  <app-banner *ngIf="commissioningStore.isDeviceNotAssignedToHeatingCircuit(deviceId) | async">
    <span data-at-comissioning-no-hc-warning>
      {{ '+COMMISSIONING.DEVICE_INDICATOR.NO_HEATING_CIRCUIT_WARNING.TITLE' | translate }}
      <span
        *ngIf="isRemoteDeviceOfType(gatewayStore.getDeviceRoles(deviceId) | async, srcType.FHT)"
      >
        {{ '+COMMISSIONING.FLOOR_HEATING_THERMOSTAT.HEATING_CIRCUIT_WARNING.TITLE' | translate }}
      </span>
    </span>
  </app-banner>
  <ng-container
    *ngrxLet="{ device: connection$ | async, fht: fhtMainUnitConnection$ | async } as connection"
  >
    <app-banner
      *ngIf="
        installationService.isSrcDeviceNotConnected(connection.device) ||
        installationService.isSrcDeviceNotConnected(connection.fht)
      "
    >
      {{ '+INSTALLATIONS.DEVICE_STATUS.DISCONNECTED' | translate }}
      {{
          connection.device?.timestamp ?? connection.fht?.timestamp
            | dateForSpecificTimezone: (installationTimezone$ | async)
            | date: 'short'
      }}
    </app-banner>
  </ng-container>
  <app-banner *ngIf="gatewayStore.isClimateSensorBatteryLow(deviceId) | async">
    {{ '+COMMISSIONING.DEVICE_PANEL.CS.INFO_BATTERY_LOW' | translate }}
  </app-banner>
  <app-banner *ngIf="gatewayStore.isAirQualitySensorBatteryLow(deviceId) | async">
    {{ '+COMMISSIONING.DEVICE_PANEL.AIR_QUALITY_SENSOR.INFO_BATTERY_LOW' | translate }}
  </app-banner>
  <app-banner *ngIf="gatewayStore.isRadiatorValveBatteryLow(deviceId) | async">
    {{ '+COMMISSIONING.DEVICE_PANEL.ETRV.INFO_BATTERY_LOW' | translate }}
  </app-banner>
  <app-banner *ngIf="commissioningStore.isClimateSensorNotConnected(deviceId) | async"
    ><span data-at-comissioning-room-cs-unavailable-label>
      {{ '+COMMISSIONING.ROOM_INDICATOR.CS_NOT_AVAILABLE_WITH_FHT.TITLE' | translate }}
    </span>
  </app-banner>
</app-tile>
